module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cJFw9"))).then(() => module.bundle.root('5erN3'));